import clsx from 'clsx';
import Image from 'next/image';
export const Token = ({
  token,
  size,
}: {
  token: string;
  size: 'large' | 'medium' | 'normal';
}) => {
  const wh = size === 'large' ? 40 : size === 'medium' ? 32 : 16;
  return (
    <Image
      src={`/token/${token.toLowerCase()}.svg`}
      width={wh}
      height={wh}
      alt={token}
    />
  );
};

export const Chain = ({
  chain,
  size,
}: {
  chain: string;
  size: 'large' | 'medium' | 'normal';
}) => {
  const wh = size === 'large' ? 40 : size === 'medium' ? 32 : 16;
  return (
    <Image
      src={`/chain/${chain.toLowerCase()}.svg`}
      width={wh}
      height={wh}
      alt={chain}
    />
  );
};

export const TokenChainIcon = ({
  name = '',
  src = '',
  className = '',
  style,
  address,
}: {
  src?: string;
  className?: string;
  name?: string;
  style?: React.CSSProperties;
  address?: string;
}) => {
  if (src === 'missing.png') {
    src = '';
  }

  if (name === undefined || name === null) name = '';
  if (src === undefined || src === null) name = '';
  const alt = name.length === 0 ? '' : name.substring(0, 1);
  if (
    name === 'BITBOT' &&
    (!address || address === '0x252D223D0550BC6c137B003D90bc74F5341A2818')
  ) {
    return (
      <Image
        width={64}
        height={64}
        alt={alt}
        src={'/bitbot-icon.png'}
        className={clsx('rounded-full flex-shrink-0', className)}
        unoptimized
        style={style}
      />
    );
  }

  if (name === 'ETH') {
    return (
      <Image
        width={64}
        height={64}
        alt={alt}
        src="/token/eth.svg"
        className={clsx('rounded-full flex-shrink-0', className)}
        unoptimized
        style={style}
      />
    );
  }

  if (src !== '') {
    return (
      <Image
        width={64}
        height={64}
        alt={alt}
        src={src}
        className={clsx('rounded-full flex-shrink-0', className)}
        unoptimized
        style={style}
      />
    );
  } else {
    return (
      <div
        className={clsx(
          'rounded-full flex items-center justify-center bg-secondary flex-shrink-0 text-[17px]',
          className,
        )}
        style={style}
      >
        {alt}
      </div>
    );
  }
};

export const TokenWithChainIcon = ({
  tokenName,
  tokenSrc,
  className,
  chainSrc,
  chainName,
  chainClassName,
  borderWidth = 5,
}: {
  tokenSrc?: string;
  className?: string;
  tokenName: string;
  chainSrc?: string;
  chainName: string;
  chainClassName?: string;
  borderWidth?: number;
}) => {
  return (
    <div className={clsx('relative inline-flex', className)}>
      <TokenChainIcon
        src={tokenSrc}
        name={tokenName}
        className={className}
      />
      <TokenChainIcon
        src={chainSrc}
        name={chainName}
        className={clsx(
          'absolute bottom-[-4%] right-[-4%] border-black w-[100%] h-[100%] origin-bottom-right scale-[0.46]',
          chainClassName,
        )}
        style={{ borderWidth }}
      />
    </div>
  );
};
